import { IExamQuestionAdminMetaUm } from '../models/exam-question-admin-meta-up';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IExamQuestionVm } from '../models/exam-question-vm';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PutQuestionBaseService {

  private http = inject(HttpClient);

  public putQuestionsBase$(data: IExamQuestionAdminMetaUm): Observable<IExamQuestionVm> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<IExamQuestionVm>(environment.webApiUrl + '/QuestionBase', data, { headers });

  }
}
